import { CRITERION_VALUE } from "@/constants/criterion-values"
import { AlertTriangle, Check, X } from "lucide-react"

import type { CriterionResult } from "../../types"

const CriterionIcon: React.FC<{
  result: CriterionResult["result"]
  onSurface?: boolean
}> = ({ result, onSurface }) => {
  const base = "w-3.5 h-3.5 flex-shrink-0 mt-0.5"
  if (result === CRITERION_VALUE.MET) {
    return (
      <Check
        className={`${base} ${onSurface ? "text-coval-success-on-surface" : "text-coval-success-text"}`}
      />
    )
  }
  if (result === CRITERION_VALUE.NOT_MET) {
    return (
      <X
        className={`${base} ${onSurface ? "text-coval-danger-on-surface" : "text-coval-danger-text"}`}
      />
    )
  }
  return (
    <AlertTriangle
      className={`${base} ${onSurface ? "text-coval-warning-on-surface" : "text-coval-warning-text"}`}
    />
  )
}

export const CriteriaDetailList: React.FC<{
  criteria: CriterionResult[]
  conflictIndices?: Set<number>
}> = ({ criteria, conflictIndices }) => {
  if (criteria.length === 0) {
    return <span className="text-xs text-coval-text-muted">N/A</span>
  }
  return (
    <div className="flex flex-col gap-2" role="list">
      {criteria.map((c, i) => {
        const isConflict = conflictIndices?.has(i) ?? false
        return (
          <div
            key={i}
            className={`flex items-start gap-1.5 ${isConflict ? "bg-coval-danger-surface -mx-1 px-1 rounded" : ""}`}
            role="listitem"
          >
            <CriterionIcon result={c.result} onSurface={isConflict} />
            <div className="flex flex-col gap-0.5">
              <span
                className={`text-xs font-medium ${isConflict ? "text-coval-danger-on-surface" : "text-coval-text"}`}
              >
                {c.criterion}
                <span className="sr-only">
                  {" "}
                  —{" "}
                  {c.result === CRITERION_VALUE.MET
                    ? "Met"
                    : c.result === CRITERION_VALUE.NOT_MET
                      ? "Not met"
                      : "Unknown"}
                </span>
              </span>
              {c.explanation && (
                <span
                  className={`text-xs ${isConflict ? "text-coval-danger-on-surface" : "text-coval-text-muted"}`}
                >
                  {c.explanation}
                </span>
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}
